export const TRANSPORT_TYPES_DEFAULT = ["aircraft", "bus", "train"] as const
export const CABIN_TYPE_MIXED_ALLOWED_DEFAULT = false
export const MAX_TRAVEL_DURATION_DEFAULT = 60
